import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { Delivery } from "./components/Delivery";
import { Divider } from "./components/Divider";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { SiteCredits } from "./components/SiteCredits";
// import { products } from "./data/products";
import { Contacts } from "./components/Contacts";
import { WorkingHours } from "./components/WorkingHours";
import "./App.css";
import { getIsStoresLoading, getStores } from "./redux/selectors";
import { fetchStores } from "./redux/stores/operations";
import { Products } from "./components/Products";
import { RadarLoader } from "./components/RadarLoader";
// import { Announce } from "./components/Announce";
import { UpdatesBanner } from "./components/UpdatesBanner";

function App() {
  const dispatch = useDispatch();
  const storesData = useSelector(getStores);
  const isStoresLoading = useSelector(getIsStoresLoading);

  const isDataLoading = isStoresLoading || storesData.length === 0;

  useEffect(() => {
    if (storesData.length === 0) {
      dispatch(fetchStores());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isDataLoading) {
    return <RadarLoader />;
  }

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <div className="App relative" id="home">
          <Header />
          <Contacts position={"top"} />
          <WorkingHours />
          <UpdatesBanner />
          {/* <Announce /> */}
          {/* <Devider /> */}
          <Delivery />
          <Products />
          <Divider />
          <Footer />
          <SiteCredits />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
